import { UpdateNodesContext } from '@/context/UpdateNodesContext';
import { useContext } from 'react';

export const useUpdateNodes = () => useContext(UpdateNodesContext);
